import Service from './service';
import { Auth } from 'aws-amplify';
import {ORDER_ACCEPTED, ORDER_REJECTED, TRADE_COMPLETED, TRADE_REJECTED} from "../helpr/constants";

class SecurityService extends Service {
  constructor() {
    super("SECURITY_SERVICE");
  }

  getListOfSecuritiesOnOffer = (status) => {
    const queryParams = typeof status !== 'undefined' ? {status: status} : {}
    return this.get('/offers', queryParams);
  }

  getSecurityOffer = securityId => {
    return this.get(`/offers/${securityId}`);
  }

  getSecurityDetail = (securityId) => {
    return this.get(`/securities/${securityId}`);
  }

  getSecurityDocument = securityId => {
    return this.get(`/offers/${securityId}/file`);
  }

  getListOfOrders = securityId => {
    return this.get(`/offers/${securityId}/orders`, {
      fields: 'sortKey,purchaseAmount,scaledAmount,primaryApplicant,orderId,generatedFromFileUpload,refNumber,orderStatus,createdDate'
    });
  }

  generateSalesReport = (securityId, entityId=null) => {
    let qparams = {};
    if( entityId ){ qparams['entityId'] = entityId };
    return this.get(`/offers/${securityId}/salesreport`, qparams);
  }

  generateBPFeed = (securityId, entityList) => {
    return this.get(`/securities/${securityId}/bpfeed`, { entityList: entityList });
  }

  allocateSecurity = (securityId, entityList) => {
    return this.get(`/securities/${securityId}/allocate`, { entityList: entityList });
  }

  patchOrdersId = (idType, securityId, entityId, generatedId) => {
    return this.patch(`/securities/${securityId}/id`, {
      idType: idType,
      entityId: entityId
    },{
      generatedId: generatedId
    })
  }

  getOrder = (securityId, orderId) => {
    return this.get(`/offers/${securityId}/orders/${orderId}`);
  }

  acceptOrder = (securityId, orderId) => {
    return this.patch(`/offers/${securityId}/orders/${orderId}`, {}, {
      orderStatus: ORDER_ACCEPTED
    });
  }

  rejectOrder = (securityId, orderId) => {
    return this.patch(`/offers/${securityId}/orders/${orderId}`, {}, {
      orderStatus: ORDER_REJECTED
    });
  }

  getUploadOrderListPresignedUrl = (securityId, applicationId, id, filename, filetype) => {
    return this.get(`/offers/${securityId}/orders/upload/`, {
      id: id,
      applicationId: applicationId,
      filename : filename,
      filetype: filetype
    });
  }

  createOrder = (securityId, sessionId, orderObj) => {
    return this.unauthenticatedPost(`/offers/${securityId}/orders`,{
      sessionId : sessionId
    }, orderObj);
  }

  uploadOrderListFile = (path, file) => {
    return this.unsignedPut(path, file, {
      headers : {
        'Content-Type' : 'text/csv'
      }
    });
  }

  scaleDownOrder = (securityId, orderId, amount) => {
    return this.patch(`/offers/${securityId}/orders/${orderId}`, {}, {
      scaledAmount: parseFloat(amount)
    });
  }

  batchAcceptOrder = (securityId, orderIdList) => {
    return this.patch(`/offers/${securityId}/orders`, {}, {
      orderStatus: ORDER_ACCEPTED,
      orderIdList: orderIdList
    });
  }

  batchRejectOrder = (securityId, orderIdList) => {
    return this.patch(`/offers/${securityId}/orders`, {}, {
      orderStatus: ORDER_REJECTED,
      orderIdList: orderIdList
    });
  }

  submitOrders = securityId => {
    return this.patch(`/offers/${securityId}/submit`);
  }

  getAllSecurities = () => {
    return this.get('/securities');
  }

  getSecuritySellingAgents = securityId => {
    return this.get(`/securities/${securityId}/sellingagents`);
  }

  downloadOrderList = securityId => {
    return this.get(`/offers/${securityId}/orders/download`);
  }

  authorizeOrders = securityId => {
    return this.patch(`/offers/${securityId}/authorize`);
  }

  rejectOrders = securityId => {
    return this.patch(`/offers/${securityId}/reject`);
  }

  generateSecurityBpId = (securityId, entityId, idType, prefix) => {
    return this.patch(`/securities/${securityId}/orders/${entityId}/generateSequence`, {
      idType: idType
    },{
      prefix: prefix
    })
  }

  batchDownloadATP = (securityId) => {
    return this.get(`/securities/${securityId}/atp`);
  }

}

export default SecurityService;

